"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _container = _interopRequireDefault(require("../container"));

var _heading = _interopRequireDefault(require("../heading"));

var _logo = _interopRequireDefault(require("../logo"));

var _anglePatternInline = _interopRequireDefault(require("./angle-pattern.inline.svg"));

var _nav = _interopRequireDefault(require("./nav"));

var _menu = _interopRequireDefault(require("./menu"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var UniversalHeader = function UniversalHeader(_ref) {
  var _classNames;

  var children = _ref.children,
      logoLink = _ref.logoLink,
      className = _ref.className,
      colour = _ref.colour,
      cartItemCount = _ref.cartItemCount,
      cartLink = _ref.cartLink,
      accountMenuItems = _ref.accountMenuItems,
      navigationMenu = _ref.navigationMenu,
      pageTitle = _ref.pageTitle,
      createLinkElement = _ref.createLinkElement,
      PageTitleLink = _ref.pageTitleLink;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.Header, className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _indexModule.default.seasonal, colour === 'seasonal'), (0, _defineProperty2.default)(_classNames, _indexModule.default.minimal, colour === 'minimal'), (0, _defineProperty2.default)(_classNames, _indexModule.default.brand, colour === 'brand'), _classNames)),
    role: "banner"
  }, /*#__PURE__*/_react.default.createElement(_anglePatternInline.default, {
    "aria-hidden": "true",
    className: _indexModule.default.svg
  }), /*#__PURE__*/_react.default.createElement(_container.default, {
    className: _indexModule.default.container,
    type: "large"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.logoWrapper
  }, /*#__PURE__*/_react.default.createElement(_logo.default, {
    url: logoLink,
    className: _indexModule.default.logo
  }), /*#__PURE__*/_react.default.createElement(_nav.default, {
    cartItemCount: cartItemCount,
    cartLink: cartLink,
    accountMenuItems: accountMenuItems
  })), children, pageTitle && /*#__PURE__*/_react.default.createElement(_heading.default, {
    type: "large",
    className: _indexModule.default.pageTitle
  }, PageTitleLink ? /*#__PURE__*/_react.default.cloneElement(PageTitleLink, {
    className: _indexModule.default.pageTitleLink
  }, pageTitle) : pageTitle), /*#__PURE__*/_react.default.createElement(_container.default, {
    className: navigationMenu.length > 0 ? _indexModule.default.hasNavigation : _indexModule.default.noNavigation,
    type: "large"
  })), navigationMenu.length > 0 && /*#__PURE__*/_react.default.createElement(_menu.default, {
    className: _indexModule.default.background,
    navigationMenu: navigationMenu,
    createLinkElement: createLinkElement
  }));
};

UniversalHeader.propTypes = {
  children: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.node), _propTypes.node]),
  logoLink: _propTypes.string,
  className: _propTypes.string,
  colour: (0, _propTypes.oneOf)(['brand', 'minimal', 'seasonal']),
  cartItemCount: _propTypes.number,
  accountMenuItems: _propTypes.array,
  navigationMenu: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.node), _propTypes.node, _propTypes.array]),
  pageTitle: _propTypes.string,
  pageTitleLink: _propTypes.node,
  cartLink: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),

  /**
   * An optional decorator function for links.
   *
   * The renderer must have the following signature:
   *
   * (item) => ReactElement
   *
   * Where the ReactElement is a clickable link (i.e 'a', 'Link'). The
   * navigation item object {label: string, url: string} is passed to
   * the function, which creates a wrapper element with any props provided
   *  (which may be overwritten by additional props passed to the component)
   */
  createLinkElement: _propTypes.func
};
UniversalHeader.defaultProps = {
  children: [],
  logoLink: 'https://www.westfield.com.au',
  className: null,
  colour: 'seasonal',
  navigationMenu: []
};
var _default = UniversalHeader;
exports.default = _default;